import VText from './vnode/vtext'

export default function createVText (text) {
  return new VText(text)
}
